export const MERCHANT_RYOU = '8b036c3e-e021-4512-a9f5-17819b5f9d7c'
export const MERCHANT_616 = '4f9f5c97-1814-4fce-91cc-656a9bb8d3bf'
export const MERCHANT_TIM_GEI = '00f2083e-cc42-4fcf-a0e4-aa89d92c9524'
export const SOGNO_CAFE = '4fade609-e22e-4d63-9bb1-515bd74eae4e'
export const MERCHANT_BAKSO = '04ba8fc1-0a89-4b2b-8abb-46a1ce1619ae'
export const MERCHANT_SNAKEKING = 'd4b2a7f4-4c31-4b42-a502-5db5dc4703c9'
export const MERCHANT_GOLDENPIG = '1ff343a2-a59b-4208-bc76-9ccce7778a94'
export const MERCHANT_YEUNGWOOTONG = '648c4cf5-9ccb-48e0-880e-e9e99f72a359'
export const MERCHANT_YATBUNKITCHEN = 'd3b87c10-60cf-4818-a0a2-66ccc42c937b'
export const MERCHANT_YORU = '55a3aee8-98eb-4725-9379-b03a5da9c291'
export const MERCHANT_CAMPAIGN_CCB_1 = '0e9527f0-fe41-49c2-a217-2af62a965f42'
export const MERCHANT_CAMPAIGN_CCB_2 = '90306864-803d-4734-b1d8-f3e0304b310a'
export const MERCHANT_CAMPAIGN_CCB_3 = '41350934-bc5a-460e-94cf-748c4c7f55a1'

export const MERCHANT_MIDNIGHT = '1'
export const MERCHANT_WING3 = '3'
export const MERCHANT_GRANDDINGHOISE = 'dbd5ed68-83fb-497f-b1e2-82636aa02e4b'
export const MERCHANT_BETA_PAK = '28f7f571-616a-451d-b832-bc7305525883'

export const YEUNGWOOTONG_PICKUP_LOCATIONS = [
  { name: '藍田啟田道49號地下8B號舖', address: '藍田啟田道49號地下8B號舖' },
  { name: '大圍大圍道71號富嘉花園30A舖', address: '大圍大圍道71號富嘉花園30A舖' },
  { name: '元朗阜財街14號宏豐大廈地下10號舖', address: '元朗阜財街14號宏豐大廈地下10號舖' },
]

export const AVAILABLE_DROPOFF_LOCATIONS = [
  { name: '律敦治醫院', address: '灣仔皇后大道東266號' },
  { name: '鄧肇堅醫院', address: '灣仔皇后大道東282號' },
  // 0331 add new clinic
  { name: 'LM SKINCENTRE', address: '香港灣仔告士打道80號16樓' },
  { name: 'Mann Darren Vivian 診所', address: '香港灣仔皇后大道東231-233號恆威商業大廈8樓' },
  { name: 'OT&P Medical Practice (灣仔)', address: '香港灣仔港灣道8號瑞安中心1501室' },
  { name: 'Wendy Anne Mabbott 診所', address: '香港灣仔港灣道6-8號瑞安中心15樓1501-1503室' },
  { name: 'William Richard Tinlin 診所', address: '香港灣仔港灣道6-8號瑞安中心15樓1501-1504室' },
  { name: '上醫林中醫診所 (灣仔新禧大樓)', address: '香港灣仔軒尼詩道68-76號新禧大樓4樓E室' },
  { name: '中大醫學Ｘ光化驗所 (友誼大廈)', address: '灣仔軒尼詩道345號友誼大廈2字樓' },
  { name: '位元堂中醫診所 (灣仔)', address: '香港灣仔軒尼詩道151號地下' },
  { name: '何世坤診所', address: '香港灣仔莊士敦道120號宜興大廈三樓' },
  { name: '何樹勛診所', address: '香港灣仔春園街6-12號永興樓1樓' },
  { name: '健活物理治療 (軒尼詩道)', address: '香港灣仔軒尼詩道217號地下' },
  { name: '劉偉一診所', address: '香港灣仔 盧押道13號 修頓商業大廈5字樓' },
  { name: '區華昌診所', address: '香港灣仔軒尼詩道199號東華大廈501室' },
  { name: '司徒立奇診所', address: '香港灣仔太源街38號地下' },
  { name: '吳金耀診所', address: '香港灣仔莊士敦道128號台山中心8字樓A室' },
  { name: '姚耀基診所', address: '香港灣仔港灣道1號會展廣場辦公大樓1109室' },
  { name: '姜智偉診所', address: '香港灣仔軒尼詩道302-308號集成中心21樓2111室' },
  { name: '小天使兒科診所 (東美中心)', address: '香港灣仔皇后大道東43-59號東美中心14樓1401室' },
  { name: '屈靖鵬診所', address: '香港灣仔灣仔道149號樂景大樓地下1C及1D號舖' },
  { name: '康健國際健康管理中心 (灣仔)', address: '灣仔軒尼詩道313號中國人壽大廈1樓' },
  { name: '康德堂中醫診所 (灣仔)', address: '香港灣仔譚臣道105-111號豪富商業大廈19樓B室' },
  { name: '廖勵行診所', address: '香港灣仔莊士敦道128號台山中心12樓A室' },
  { name: '張勇醫館 (灣仔)', address: '香港灣仔謝斐道90號11樓全層' },
  { name: '德承微創植齒中心 (灣仔)', address: '灣仔莊士敦道197號' },
  { name: '心視角有限公司 (東新商業中心)', address: '香港灣仔駱克道 194-200 號東新商業中心1 樓' },
  { name: '恆康醫務中心', address: '香港灣仔春園街38號地下' },
  { name: '招雄亮診所', address: '香港灣仔軒尼詩道250號卓能廣場22樓B室' },
  { name: '新廣大(祥興)醫學X光化驗', address: '香港灣仔軒尼詩道 265-267 號祥興大廈 1字樓 A-B室' },
  { name: '曾志明診所', address: '香港灣仔軒尼詩道40號地下' },
  { name: '東南醫學中心', address: '香港灣仔軒尼斯道 245 - 251 號守時商業大廈 5 樓 B 室' },
  { name: '梁世光診所', address: '香港灣仔菲林明道7號好發商業大廈11樓' },
  { name: '梁均鉅診所', address: '香港灣仔莊士敦道128號台山中心7字樓7A室' },
  { name: '楊恩妮診所', address: '香港灣仔壯士敦道163號勝任商業大廈8樓' },
  { name: '欣齒牙科診所', address: '香港灣仔灣仔道181號長春大廈地下E號地舖' },
  { name: '歐陽卓斌診所', address: '香港灣仔軒尼詩道397號東區商業大廈601室' },
  { name: '沈秉韶診所', address: '香港灣仔港灣道6-8號瑞安中心2101-2103室' },
  { name: '港恩中醫診所 (灣仔)', address: '香港灣仔軒尼詩道107-115號協生大廈3樓' },
  { name: '湯儒偉診所', address: '香港灣仔軒尼詩道263號新軒尼詩大廈8樓' },
  { name: '灣仔物理治療中心', address: '香港灣仔莊士敦道128號台山中心5樓A&B室' },
  { name: '王功超診所', address: '香港灣仔軒尼詩道187號濂風大廈1樓' },
  { name: '王家堅診所', address: '灣仔太原街43-45號富恒樓4樓B座' },
  { name: '王志釗診所', address: '香港軒尼詩道163號5樓' },
  { name: '王春波醫生醫務所', address: '香港灣仔駱克道68-70號偉信商業大廈3字樓' },
  { name: '王陶村診所', address: '香港灣仔莊士敦道128號台山中心6樓6A室' },
  { name: '玲瓏中醫診所', address: '香港灣仔譚臣道17-23號壬子商業大廈8樓B室' },
  { name: '盧思詩診所', address: '香港灣仔莊士敦道128號台山中心6樓6A室' },
  { name: '盧永興診所', address: '香港灣仔莊士敦道181號大有大廈1302室' },
  { name: '竺培鎮診所', address: '香港灣仔柯布連道3號3樓B座' },
  { name: '綽力物理治療中心 (灣仔)', address: '香港灣仔莊士敦道178號華懋莊士敦廣場11樓1103室' },
  { name: '羅志明診所', address: '香港灣仔皇后大道東213號胡忠大廈21樓衛生署' },
  { name: '聖雅各福群會賽馬會R3綜合體健中心', address: '香港灣仔堅尼地道112號13樓' },
  { name: '聯合醫務中心 (灣仔)', address: '香港灣仔港灣道1號會展廣場辦公大樓1109室' },
  { name: '英思中醫診所', address: '香港灣仔莊士敦道170號美華大廈1字樓' },
  { name: '華彩康復治療中心', address: '香港灣仔摩利臣山道80-82號柏餘中心3樓01室' },
  { name: '蔡慶和診所', address: '香港灣仔克街14號地下' },
  { name: '袁志忠診所', address: '香港灣仔軒尼詩道302-308號集成中心15樓1512室' },
  { name: '謝思名診所', address: '香港灣仔謝斐道408-412號華斐商業大廈8樓806室' },
  { name: '賴鎮山診所', address: '香港灣仔莊士敦道163號勝任商業大廈20樓1&2室' },
  { name: '農本方中醫診所 (灣仔利東街)', address: '香港灣仔皇后大道東200號利東街地庫1樓B39號舖' },
  { name: '農本方中醫診所 (灣仔會展)', address: '香港灣仔港灣道1號會展廣埸 1樓105B號舖' },
  { name: '農本方中醫診所 (灣仔集成)', address: '香港灣仔軒尼詩道302-308號集成中心UG層12號舖' },
  { name: '迅康復康治療中心 (灣仔)', address: '香港灣仔莊士敦道120號宜興大廈17樓' },
  { name: '郭靖診所', address: '香港灣仔盧押道11-13號修頓商業中心2A室' },
  { name: '鄭萃診所', address: '香港灣仔莊士敦道163號勝任商業大廈10樓' },
  { name: '鄭鐘平診所', address: '香港灣仔柯布連道1號東興大廈12字樓A座' },
  { name: '陳仲文診所', address: '灣仔軒尼詩道269號A光華大廈9字樓' },
  { name: '陳偉文診所', address: '香港灣仔軒尼詩道319號C座一樓' },
  { name: '陳榮新診所', address: '香港灣仔軒尼詩道67號地下' },
  { name: '陳秩恂診所', address: '香港灣仔港灣道8號瑞安中心106-7室' },
  { name: '靈光醫養復康 (金利大廈)', address: '香港灣仔摩利臣山道20-30號金利大廈地下A1舖' },
  { name: '香港家庭計劃指導會 (灣仔)', address: '香港灣仔軒尼詩道130號修頓中心地下' },
  { name: '魏金娘診所', address: '香港灣仔太原街43-45號富恒樓4字樓B室' },
  { name: '麥展聲診所', address: '香港灣仔莊士敦道163號勝任商業大廈3/A' },
  { name: '麥展聲診所', address: '香港灣仔莊士敦道163號勝任商業大廈3A' },
  { name: '麥穎和診所', address: '香港灣仔軒尼詩道210號玉滿樓二樓102室' },
  { name: '黃喜良診所', address: '香港灣仔道113-117號得利商業大廈5E室' },
  { name: '黃振邦診所', address: '香港軒尼詩道273號2樓' },

  { name: '渣打銀行灣仔修頓分行', address: '灣仔軒尼詩道156-162號利榮大樓地下C2舖' },
  { name: '渣打銀行灣仔鷹君分行', address: '灣仔港灣道23號鷹君中心1樓113-120號舖' },
  { name: '滙豐熙華大廈分行', address: '灣仔軒尼詩道71-85號熙華大廈B座' },
  { name: '恒生銀行 - 莊士敦道分行', address: '灣仔莊士敦道142號' },
  { name: '恒生銀行 - 灣仔聯合鹿島大廈分行', address: '1/F, 聯合鹿島大廈, 灣仔告士打道138號' },
]
export const DELIVERY_PROMOCODES = [
  'd85',
  'paktest',
  'luckyyyyynoodle',
  'ovotakeaway20OfF',
  'TzakeoawaydOF5F',
  'hikawa',
  'Chi2cken',
  'localgindoger',
  'timeeeDoee',
  'nuro20ffovocafe',
  'nurhikawa',
  'nurTzakeoawaydoff',
  'nurchi2cken',
  'NurSharemon',
  'nurlocalgindoger',
  'NurLunckyy',
]

export const DELIVERY_TYPE_DELIVERY = 'delivery'
export const DELIVERY_TYPE_SHOP = 'shop'
export const DELIVERY_TYPE_STOREDELIVERY = 'storeDelivery'
export const DELIVERY_TYPE_TAKEAWAY = 'takeaway'

export const FIRST_DATA_MERCHANTS = [
  // '3',
  // '28f7f571-616a-451d-b832-bc7305525883', // beta kelvin
]



// WEBPACK FOOTER //
// ./src/constants/merchant.js